import { useWarehouse } from "./useWarehouse";
import { useSteps } from "./useSteps";

import { PackageLookup } from "./PackageLookup";
import { CapturePackagePhotos } from "./CapturePackagePhotos";
import { CheckContents } from "./CheckContents";
import { ControlWeightCapture } from "./ControlWeightCapture";
import { PackagingWeightCapture } from "./PackagingWeightCapture";
import { ContentWeightCapture } from "./ContentWeightCapture";
import { NonConformPhoto } from "./NonConformPhoto";
import { SortContents } from "./SortContents";
import { AssembledWeightCapture } from "./AssembledWeightCapture";
import { ConformingWeightCapture } from "./ConformingWeightCapture";
import { CaptureScaleReadingPhoto } from "./CaptureScaleReadingPhoto";
import { Summary } from "./Summary";
import { ProcessingIssues } from "./ProcessingIssues";
const getFlags = (takeback) => ({
  LEGO: takeback?.product_id === "lego-bricks",
});

export const useConfiguration = () => ({
  isStepVisible: (step) => isStepVisible(step),
  isStepValid: (step) => isStepValid(step),
  stepsRequiredOnCheckIn: () => stepsRequiredOnCheckIn(),
});

export const isStepValid = (step) => {
  const {
    packagePictures,
    hasCheckedContents,
    controlWeight,
    packagingWeight,
    contentWeight,
    sortedPictures,
    assembledWeight,
    conformingWeight,
    scaleReadingPictures,
    nonConformPictures,
  } = useWarehouse.getState();

  if (step === ProcessingIssues || step === PackageLookup) {
    return true;
  }

  if (step === CapturePackagePhotos) {
    return packagePictures.length > 0;
  }
  if (step === CheckContents) {
    return hasCheckedContents;
  }
  if (step === ControlWeightCapture) {
    return controlWeight !== "";
  }
  if (step === PackagingWeightCapture) {
    return packagingWeight !== "";
  }
  if (step === ContentWeightCapture) {
    return contentWeight !== "";
  }
  if (step === NonConformPhoto) {
    return nonConformPictures.length > 0; // Required - must have at least one photo
  }
  if (step === SortContents) {
    return sortedPictures.all !== undefined;
  }
  if (step === AssembledWeightCapture) {
    return assembledWeight !== "";
  }
  if (step === ConformingWeightCapture) {
    return conformingWeight !== "";
  }
  if (step === CaptureScaleReadingPhoto) {
    return scaleReadingPictures.length > 0;
  }
  if (step === Summary) {
    return true;
  }

  return false;
};

export const isStepVisible = (step) => {
  const { takeback } = useWarehouse.getState();
  const { dropStoreMode } = useSteps.getState();

  if (!takeback) {
    return false;
  }

  // PackagingWeightCapture is only visible in Drop Store mode
  if (step === PackagingWeightCapture && !dropStoreMode) {
    return false;
  }

  // CheckContents is only visible in Mail-in mode (not in Drop Store mode)
  if (step === CheckContents && dropStoreMode) {
    return false;
  }

  if (getFlags(takeback).LEGO && [AssembledWeightCapture].includes(step)) {
    return false;
  }

  return true;
};

export const stepsRequiredOnCheckIn = (takeback) => {
  const currentTakeback =
    takeback || useWarehouse.getState((state) => state.takeback);
  const { dropStoreMode } = useSteps.getState();

  if (!currentTakeback) {
    return [];
  }
  if (getFlags(currentTakeback).LEGO) {
    // In drop store mode, don't include CheckContents
    if (dropStoreMode) {
      return [CapturePackagePhotos];
    }
    return [CapturePackagePhotos, CheckContents];
  }
  return [];
};
